module.exports = __webpack_public_path__ + "img/home_ic_cye@3x.ad1e72bf.png";